const StandingsTable = ({ teams }) => (
  <div className="league-table-container scroll-on-overflow">
    <table className="table league-table">
      <thead className="league-table-heading-hole">
        <tr>
          <th className="league-table-heading-name"><span>TEAM</span></th>
          <th className="league-table-heading hole"><span>W</span></th>
          <th className="league-table-heading hole"><span>L</span></th>
          <th className="league-table-heading hole"><span>PCT</span></th>
          <th className="league-table-heading hole"><span>PF</span></th>
          <th className="league-table-heading hole"><span>PA</span></th>
          <th className="league-table-heading hole"><span>+/-</span></th>
          <th className="league-table-heading hole"><span>Strk</span></th>
        </tr>
      </thead>
      <thead className="league-table-heading-total">
        <tr>
          <th className="league-table-heading-name"><span>TEAM</span></th>
          <th className="league-table-heading-small" style={{ minWidth: '55px' }}><span>W - L</span></th>
          <th className="league-table-heading-small"><span>PCT</span></th>
        </tr>
      </thead>
      <tbody>
        {(teams || []).map((team, i) => (
          <tr key={team.id}>
            <td className="league-table-data-name user-name no-wrap">
              <span className="team-standings-link">{i + 1}. </span>
              <a className="team-standings-link" href={`/teams/${team.id}`}>{team.name.toUpperCase()}</a>
            </td>
            <td className="league-table-data desktop-only"><span>{team.wins}</span></td>
            <td className="league-table-data desktop-only"><span>{team.losses}</span></td>
            <td className="league-table-data wide-fixed mobile-only"><span>{team.wins}-{team.losses}</span></td>
            <td className="league-table-data wide"><span>{team.winPercentage}</span></td>
            <td className="league-table-data wide desktop-only"><span>{team.pointsFor}</span></td>
            <td className="league-table-data wide desktop-only"><span>{team.pointsAgainst}</span></td>
            <td className="league-table-data wide desktop-only"><span>{team.pointsFor - team.pointsAgainst}</span></td>
            <td className="league-table-data wide-fixed desktop-only"><span>{team.streak}</span></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default StandingsTable;
